module.exports = __webpack_public_path__ + "img/Growth-action.b5805c4a.svg";